import React from "react";

// "Your Privacy Choices" with the official California opt-out icon beside it. CCPA (Cal. Civ. Code
// § 1798.135(a)(3) and the CPPA regulations) only accepts this title as the opt-out link if the icon is
// shown with it, so the two always render together. Icon: California AG, privacyoptions.svg.
export default function PrivacyChoicesLabel({ iconHeight = 14 }) {
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: iconHeight / 2, whiteSpace: "nowrap" }}>
      Your Privacy Choices
      <img
        src="/images/privacyoptions.svg"
        alt="California Consumer Privacy Act (CCPA) Opt-Out Icon"
        width={Math.round((iconHeight * 30) / 14)}
        height={iconHeight}
        style={{ display: "inline-block" }}
      />
    </span>
  );
}
